import { Flex } from 'antd'

import AIPageContainer from 'src/components/AIAssistant/AIPageContainer'
import BehaviorForm from 'src/pages/AIAssistantRoutingPage/BehaviorForm'
import RoutingTable from 'src/pages/AIAssistantRoutingPage/RoutingTable'

const AIAssistantRoutingPage = () => {
  return (
    <AIPageContainer
      title="Community Assistant Routing"
      subtitle="Intelligently route residents to the right department or contact based on their question topic."
    >
      <Flex vertical gap="48px">
        <RoutingTable />
        <BehaviorForm />
      </Flex>
    </AIPageContainer>
  )
}

export default React.memo(AIAssistantRoutingPage)
